<template>
  <div>
    <QS-h4-title title="紧急联系人" />
    <QS-column-box
      v-for="(item, index) in data"
      :key="index"
      :source="item"
      :column="3"
      labelWidth="150"
      separator=":"
      :list="emergencyContactConf"
    />
  </div>
</template>
<script setup>
import { ref } from 'vue'

// 紧急联系人
const emergencyContactConf = ref([
  { key: 'emergencyContact', name: '紧急联系人姓名' },
  { key: 'emergencyContactRelation', name: '紧急联系人关系' },
  { key: 'emergencyContactTel', name: '紧急联系人手机号' },
])
defineProps({
  data: {
    type: Array,
    default: () => [],
  },
})
</script>
<script>
export default {
  name: 'EmergencyContact',
}
</script>
